import { useNavigate } from 'react-router';

const QuizCompletionModal = ({ isOpen, sessionId }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="modal modal-open">
      <div className="modal-box text-center">
        <div className="text-5xl mb-4">🎉</div>
        <h3 className="font-bold text-xl mb-2">Quiz Completed!</h3>
        <p className="text-gray-600 mb-6">You've successfully completed the quiz.</p>
        <div className="modal-action justify-center">
          <button 
            className="btn btn-primary"
            onClick={() => navigate(`/quizzes/${sessionId}/results`, {replace: true})}
          >
            View Results
          </button>
        </div>
      </div>
    </div>
  );
};

export default QuizCompletionModal;
